import * as React from 'react'
import Paper from 'material-ui/Paper'
import {MessageWithTranslation} from '../../../Entities/MessageWithTranslation.entity.evolve'

export function getValuedText(oldText: string) {
    return (message: MessageWithTranslation) => {
        if (message.id === 0) {
            return oldText
        } else {
            return message.translation
        }
    }
}

export function getDisplayedText(message: MessageWithTranslation) {
    return message.translation + ' (' + message.text + ')'
}

// tslint:disable-next-line
export function getRenderFunctionForMessageSuggestions({containerProps, children}: any) {
        return (
            <Paper {...containerProps} >
                {children}
            </Paper>
        )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ProductCalculationImport/AutoSuggestions/AutoSuggestionHelper.tsx